import angular from 'angular';

import Component from './form-submission-error.component';

const FormSubmissionError = angular
    .module('control-room.commons.form.components.form-submission-error', [])
    .component('crFormSubmissionError', Component);

export default FormSubmissionError;
